<script setup lang="ts">
import { cx, formatDate } from '@/assets/js/filters'

interface TimelineOption {
    heading: string
    date: string
    text: string
}

defineProps<{
    options: TimelineOption[]
}>()
</script>
<template>
    <ol class="relative border-l border-line">
        <li
            class="mb-4 ml-4 block p-3 bg-surface border border-line rounded-lg"
            v-for="(option, index) in options"
            :key="index"
        >
            <div
                :class="
                    cx('absolute w-5 h-5 rounded-full mt-1.5 -left-2.5 border border-white', {
                        'bg-success': index === 0,
                        'bg-surface-3': index > 0
                    })
                "
            ></div>
            <div class="flex align-center justify-between mb-2">
                <h3 class="text-lg font-semibold text-fg">
                    {{ option.heading }}
                </h3>
                <time class="text-sm font-normal leading-none text-fg-subtle">{{
                    formatDate(option.date, 'DD/MM/YYYY hh:mm')
                }}</time>
            </div>
            <p class="text-base font-normal text-fg-subtle dark:text-fg-subtle">
                {{ option.text }}
            </p>
        </li>
    </ol>
</template>
<style scoped></style>
